export default __webpack_public_path__ + "static/media/logo.64a833d5.png";